import { remember } from '@tuic/cache';
import { logger } from '@tuic/logger';

import {
  CacheTag,
  createFetchWithTimeout,
  ENDPOINT_AUTH_CLIENT_CREDENTIALS_URL,
  ENDPOINT_AUTH_CREDENTIALS,
  ENDPOINT_MPS_API,
  ENDPOINT_MPS_API_TIMEOUT,
} from '../utils';

import type { CreateClientConfig } from '../generated/uis/client.gen';

export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: ENDPOINT_MPS_API,
  auth: getTokenCached,
  fetch: createFetchWithTimeout(ENDPOINT_MPS_API_TIMEOUT),
});

//TODO: Not sure if this really needs to be cached. How many MPS request we're expecting in a given time frame?
const getToken = async (): Promise<string | undefined> => {
  try {
    const tokenResponse = await fetch(ENDPOINT_AUTH_CLIENT_CREDENTIALS_URL, {
      method: 'POST',
      headers: {
        Authorization: `Basic ${btoa(ENDPOINT_AUTH_CREDENTIALS)}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const data = (await tokenResponse.json()) as Record<string, any> | null;

    if (data?.access_token) {
      return data?.access_token;
    }

    logger.error('[MPS]: No access token found in credentials response.');
  } catch (e) {
    logger.error('[MPS]: Access token could not be fetched.');
    logger.error(e);
  }

  return undefined;
};

const getTokenCached = () =>
  remember('mps-client-token', getToken, {
    tags: [CacheTag.auth, CacheTag.authTokenRequest],
    ttl: 600, // 10 minutes
  });
